import { ReactiveStore } from '@verbit-ai/frontend-common'

export type TranscriptConnectionErrorType =
    | 'auth_expired'
    | 'access_denied'
    | 'not_found'
    | 'server_overload'
    | 'server_error'
    | 'payload_too_large'

// TODO(LG-1762): temporary handling for the 4200 "session ended" close code; may be removed when editing features go live.
export type TranscriptConnectionStateStatus = 'connected' | 'disconnected' | 'connecting' | 'failed' | 'terminated'

export type TranscriptConnectionState = {
    status: TranscriptConnectionStateStatus
    /** Transport initial CRDT sync has completed. Sticky across reconnects. */
    isInitialized: boolean
    /**
     * Doc is coherent enough to paint without the cold-boot global overlay.
     * May flip true before `isInitialized` (IndexedDB cache hit) or when sync completes.
     * Not set for partial pre-sync live updates alone.
     */
    isViewable: boolean
    error: TranscriptConnectionErrorType | null
}

/** Placeholder state for DummyTranscriptClient before a real provider mounts. */
export const DEFAULT_TRANSCRIPT_CONNECTION_STATE: TranscriptConnectionState = {
    status: 'connected',
    isInitialized: false,
    isViewable: false,
    error: null,
}

/** Initial state while transcript clients are connecting. */
export const CONNECTING_TRANSCRIPT_CONNECTION_STATE: TranscriptConnectionState = {
    status: 'connecting',
    isInitialized: false,
    isViewable: false,
    error: null,
}

export class TranscriptConnectionStateManager extends ReactiveStore<TranscriptConnectionState> {
    constructor(private _connectionState: TranscriptConnectionState = CONNECTING_TRANSCRIPT_CONNECTION_STATE) {
        super()
    }

    getLocalState = () => this._connectionState

    setConnectionState = (newState: Partial<TranscriptConnectionState>) => {
        this._connectionState = { ...this._connectionState, ...newState }
        this.emit()
    }
}
